<template>
  <div>
    <div v-if="isSurveyStarted" class="survey">
      <div class="survey-header">
        <div class="title">
          <img
            src="@/assets/images/icons/survey-start.svg"
            alt="survey-start"
          />
          <span>YENİ ANKET</span>
        </div>
        <div class="subText">
          <span>Görüşleriniz bizim için değerli</span>
          <p>
            Hizmet kalitemizi artırmak için görüşlerinizi bizimle paylaşmanızı
            bekliyoruz!
          </p>
        </div>

        <AppButton
          class="surveyButton"
          title="Ankete Katıl"
          primary
          lg
          @click="startSurvey"
        />
      </div>
    </div>
    <Survey v-else :survey="survey" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import Survey from "@/components/Survey/Survey";
import { AppButton } from "@n11/so-ui-components";

const props = defineProps({
  survey: Object,
  loading: Boolean,
});

const isSurveyStarted = ref(!!props.survey?.id);

const startSurvey = () => {
  isSurveyStarted.value = !isSurveyStarted.value;
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.survey {
  padding-top: 20px;

  &-header {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: center;

    span {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: $dark-gray-5;
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 16px;

      span {
        color: $colorN80;
        text-align: center;
        font-size: 10px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        border-radius: 3px;
        background: $colorL50;
        padding: 1px 3px;
        margin-bottom: 8px;
      }
    }

    .subText {
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 12px;

      span {
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: -0.1px;
        color: $colorN80;
      }

      p {
        color: $colorN80;
        width: 292px;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.05px;
      }
    }

    .surveyButton {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 24px;
    }
  }
}
</style>
